<template>
    <div id="voice"  :style="{width:clientW+'px',height:clientH+'px'}" style="margin:0 auto">
        <div class="voiceframe">
            <div class="voiceframe-title">
                <img :src="imgPath+'voicetitle.png'" alt="">
            </div>
            <div class="voiceframe-content">
                <div class="voicelist" v-for="(item,key) in datalist" :key="key">
                    <div class="volicepeople">
                        <div class="header">
                            <img :src="imgPath+item.header" alt="">
                        </div>
                        <p class="name">{{item.name}}</p>
                    </div>
                    <div class="text" v-html="item.text"></div>
                </div>
            </div>
        </div>
        <div class="back" @click="black">
            <img :src="imgPath+'back.png'" alt="">
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            clientW:document.body.clientWidth,
            clientH:document.body.clientHeight,
            imgPath:imgPath,
            datalist:[
                {
                    header:'header/header1.jpg',
                    name:'广东跃昉科技有限公司首席技术官江朝晖',
                    text:'<p>顺德制造业发达，尤其是形成了家电、机械装备两大超2000亿元的支柱产业，这些产业向智能智造转化的过程中，对于芯片的需求是非常大的，最终促使我们选择落户顺德。公司刚成立的时候，政府牵线搭桥，带着我们见了很多客户。所以，是政府跑来找企业，而不是我们跑去找政府，这个服务理念是非常难得可贵的。</p>'
                },
                 {
                     header:'header/header2.jpg',
                    name:'尼得科电机集团中国区总裁冯光',
                    text:'<p>顺德地处粤港湾大湾区腹地，具有十分得天独厚的区位优势，提供了很方便的交通和商业条件，我们企业在人才、供应链以及客户配套方面，能够实现“自循环”。以前我们更多的是出口，现在我们通过加强本地的研发、制造，业务实现了快速增长。我特别想说的是，顺德的政务服务让人印象深刻，各位领导十分低调、务实，而且能够基于企业实际情况提供帮忙和指导。</p><p>根据规划，顺德大力发展机器人产业和智能制造的战略定位，和我们公司的未来发展方向十分匹配，我们希望利用产业方面的丰富的技术优势，结合顺德的天时地利人和，取得更大的发展。</p>'
                },
                {
                    header:'header/header3.jpg',
                    name:'西门子中国工业4.0创新中心总经理王文华',
                    text:'<p>西门子中国公司专注于工业软件，涉及的领域包括新能源汽车、工业自动化、无人驾驶等。上周我有幸到顺德参观学习，看到顺德在未来新兴战略产业的布局，比如智能制造、机器人产业等，热切希望未来能够结合顺德的实际需要，有更进一步的合作。</p>'
                },
                {
                    header:'header/header4.jpg',
                    name:'沛琰资本董事长王煜',
                    text:'<p>我们专注于外资巨头选址顾问领域，我非常看好顺德的产业生态，前期也跟大良街道签订了一个框架协议。在跟顺德政府领导的沟通中，我一直说顺德是制造业跨国公司落户的洼地。</p>'
                },
                {
                    header:'header/header5.jpg',
                    name:'上海宇培（集团）有限公司副总裁杨良军',
                    text:'听完王区长的介绍可见顺德政府的服务非常“实”，虽然我们之间的接触不多，但能感受到效率、开放。我们准备在顺德做一个供应链的华南区域总部，包括生鲜的冷链、医药冷链中心、供应链金融的服务基地，打算投资1.5-2亿美元。'
                }
            ]
        }
    },
    created(){
        this.getViewScale();
    },
    methods: {
         getViewScale(){
            if(this.clientW >= 750){
                this.clientW = 414;
                this.clientH = 730;
            }
            if(this.clientH/this.clientW > 1.5 && this.clientH/this.clientW < 1.6){
                this.screenParm = "smallScreen";
            }else if(this.clientH/this.clientW <= 1.5){
                this.screenParm = "superSmallScreen";
            }else if(this.clientH/this.clientW >= 1.8){
                this.screenParm = "bigScreen";
            }else{
                this.screenParm = "middleScreen";
            }
        },
        black(){
            this.$router.back(-1);//放回上一页
        },
    },
}
</script>
<style lang="less" scoped>
 @base:46.875rem;
#voice{
    background-image: url(https://t.shundecity.com/shzstjh2021/Home/View/Index/images/otherbg.png);
    background-size: 100% 100%;
    position: relative;
    .voiceframe{
        width: 90%;
        height: 80%;
        padding: 70/@base 20/@base 20/@base;
        position: absolute;
        top:5%;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 10px;
        box-shadow:  0 0 20px 10px rgba(255, 255, 255, 0.3);
        .voiceframe-title{
            width:334/@base;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%,-30%);
        }
        .voiceframe-content{
            width: 100%;
            height: 100%;
            overflow-y: auto;
            .voicelist{
                padding: 10/@base;
                .volicepeople{
                    padding: 20/@base 0;
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-around;
                    .header{
                        width:100/@base;
                        height: 100/@base;
                        position: relative;
                        border-radius:50% ;
                        overflow: hidden;
                        img{
                            // position: absolute;
                            // left: 50%;
                            // top: 50%;
                            // transform: translate(-50%,-50%);
                            height: 100%;
                            width: 100%;
                                object-fit: cover;

                        }
                    }
                    .name{
                        width: 80%;
                        font-size:0.7rem ;
                        font-weight: bold;
                        text-align: justify;
                    }
                }
                
                .text{
                    font-size: 0.64rem;
                    text-align: justify;
                    line-height: 1.7;
                    padding-left: 100/@base;
                }
            }
        }
    }
    .back{
        position: absolute;
        width: 113/@base;
        left: 50%;
        top: 88%;
        transform: translateX(-50%);
    }
}   
</style>


// WEBPACK FOOTER //
// src/pages/Voice.vue